import React, { Component } from "react";
import { Switch, Route, Redirect, BrowserRouter as Router } from "react-router-dom";
import Loadable from "react-loadable";
import Box from "grommet/components/Box";
import GrommetApp from "grommet/components/App";
import * as Sentry from "@sentry/browser";
//Component

import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import AppSettings from "./utils/appSettings";
import "./style/main.scss";

import { DefaultLoader } from "./components/common/DefaultLoader";
export const httpLink = new HttpLink({ uri: AppSettings.apiUrl });
export const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem("access_token");
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : ``
        }
    };
});

const Loading = () => (
    <Box full align="center" justify="center">
        <DefaultLoader />
    </Box>
);

const User = Loadable({
  loader: () => import("./screen/User"),
  loading: Loading
});


class App extends Component {
    cache = new InMemoryCache();
    notifyError = onError(({ response, graphQLErrors, networkError }) => {
        console.log("Apollo Error Catched in Link", response, graphQLErrors, networkError);
        if(graphQLErrors){
            Sentry.captureException(graphQLErrors);
        }
        if(networkError){
            Sentry.captureException(networkError);
        }
    });

    client = new ApolloClient({
        link: ApolloLink.from([this.notifyError, authLink, httpLink]),
        cache: this.cache
    });
    render() {
        return (
            <GrommetApp centered={false}>
                <ApolloProvider client={this.client}>
                    <Router>
                        <Switch>
                            <Route
                                exact
                                path="/"
                                render={props => {
                                    return <div>Root</div>;
                                }}
                            />
                            <Route
                                path="/:externalUserId"
                                render={props => (
                                    <User
                                        externalUserId={props.match.params.externalUserId}
                                    />
                                )}
                            />
                            <Redirect to="/" />
                        </Switch>
                    </Router>
                </ApolloProvider>
            </GrommetApp>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js